import { Navigate } from "react-router-dom";

export default function NotFound() {    
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1>404 Error</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><a href="/" onClick={Navigate('/')}>Inicio</a></li>
                        <li className="breadcrumb-item active">404 Error Page</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>

            <section className="content">
            <div className="error-page">
                <h2 className="headline text-warning"> 404</h2>

                <div className="error-content">
                <h3><i className="fas fa-exclamation-triangle text-warning"></i> Oops! Pagina no encontrada.</h3>

                <p>
                    No pudimos encontrar la pagina.
                    Quizas, quieras  <a href="/" onClick={Navigate('/')}>regresar al inicio</a>
                </p>

                </div>
            </div>
            </section>
        </div>
                
    )
  }